module.exports = __webpack_public_path__ + "img/info-notice.6750d2b4.svg";